import type { FaireProductEntity } from "../../entity_types/product";

export const p_cfqfamydsv: FaireProductEntity = {
  token: "p_cfqfamydsv",
  type: "product",
  name: "Grateful Dead - Bears - 20oz Camper Mug",
  brandToken: "b_3h397zd1p8",
  brandName: "Pyramid America",
  imageUrl:
    "https://cdn.faire.com/fastly/be42c99ff2a677bf2e2cc09bf53a89b8f08168fe44e6da622ccc3fb54f03251a.jpeg",
  galleryImageUrls: [],
  priceDollars: 12.75,
  description:
    "Grateful Dead – Bears – 20oz Ceramic Camper Mug \n\nSip in classic Deadhead style with the Grateful Dead – Bears 20oz ceramic camper mug, featuring the iconic Dancing Bears artwork, this mug captures the free-spirited energy and timeless vibe of the legendary band.\n\nDesigned in a sturdy camper mug shape, it’s crafted from durable ceramic with a wide base and comfortable handle—perfect for coffee, tea, or your favorite beverage whether you’re at home, on the road, or around the campfire.\n\nProduct Details:\nCapacity: 20 oz\nMaterial: High-quality ceramic\nStyle: Camper mug with wide base\nOrigin: Made in the USA \nCare: Dishwasher & microwave safe\nDesign: Iconic Grateful Dead Dancing Bears artwork\nLicense: Officially licensed Grateful Dead product\n\nPerfect For:\nGrateful Dead fans & collectors\nCoffee lovers who enjoy a larger mug\nCamping, travel, or everyday use\nBirthdays, holidays, and music-lover gifts\n\nA colorful, collectible mug made in the USA—perfect for enjoying the music, the moment, and every sip. ☕🐻",
  tags: [],
  msrpDollars: 34.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:10.930Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
